import Preview from 'src/component/Preview';
import md from '@uiw/react-native/lib/Spacing/README.md';

export const Component = () => <Preview {...md} path="/packages/core/src/Spacing/README.md" />;
